import { Link } from "react-router-dom";

type RelatedType = "case" | "intel" | "poi" | "performance" | "popularity";

/**
 * Drop-in button for any operational record. Deep-links into the New Task
 * wizard with the relatedType/id and a suggested title pre-filled — saves
 * the user from copy-pasting context into the task body.
 */
export function AssignAsTaskButton({
  relatedType,
  relatedId,
  suggestedTitle,
}: {
  relatedType: RelatedType;
  relatedId: string;
  suggestedTitle?: string;
}) {
  const params = new URLSearchParams({
    relatedType,
    relatedId,
    ...(suggestedTitle ? { title: suggestedTitle } : {}),
  });
  return (
    <Link to={`/app/tasks/new?${params.toString()}`}>
      <button>Assign as task</button>
    </Link>
  );
}
